export const industries = [
  { value: 'saas_software', label: 'SaaS / Software' },
  { value: 'retail', label: 'Retail' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'finance', label: 'Finance' },
  { value: 'education', label: 'Education' },
  { value: 'logistics', label: 'Logistics' },
  { value: 'construction', label: 'Construction' },
  { value: 'hospitality', label: 'Hospitality' },
  { value: 'media', label: 'Media' },
  { value: 'government', label: 'Government' },
  { value: 'non_profit', label: 'Non-profit' },
  { value: 'real_estate', label: 'Real Estate' },
  { value: 'legal', label: 'Legal' },
  { value: 'consulting', label: 'Consulting' },
  { value: 'energy', label: 'Energy' },
  { value: 'agriculture', label: 'Agriculture' },
  { value: 'transportation', label: 'Transportation' },
  { value: 'telecom', label: 'Telecom' },
  { value: 'automotive', label: 'Automotive' },
  { value: 'pharmaceutical', label: 'Pharmaceutical' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'food_beverage', label: 'Food & Beverage' },
  { value: 'ecommerce', label: 'E-commerce' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'hr_services', label: 'HR Services' },
  { value: 'it_services', label: 'IT Services' },
  { value: 'mining', label: 'Mining' },
  { value: 'other', label: 'Other' },
] as const;

export type IndustryValue = (typeof industries)[number]['value'];
